import { type TableParamsType } from '../../types/common';
import { type UseQueryResult, useQuery } from 'react-query';

import {
  TransferAllocateService,
  // eslint-disable-next-line camelcase
  PagedResultDto_TransferAgentApiLogDto,
} from '@wealthlane/api-services/wealthlane-award-service';

const useGetTransferAgentLog = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType,
  id: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_TransferAgentApiLogDto | undefined,
  unknown
> => {
  const { sorting, skipCount, maxResultCount } = tableInfo;
  // const { approvalStatusId: containerStatusIds } = filter;
  const transferAgentLogList = useQuery(
    ['getTransferAgentLogList', id, sorting, skipCount, maxResultCount],
    async () => {
      return await handleRequest(
        TransferAllocateService.getApiAwardApiAppTransferAllocateTransferAgentApiLogs(
          id,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    },
    {
      select: (data) => {
        if (data != null) {
          return data;
        }
      },
    }
  );

  return transferAgentLogList;
};

export default useGetTransferAgentLog;
